<app-auth-header></app-auth-header>

<!--begin::Authentication - Sign-in -->
<div class="d-flex flex-center" style="height: 100vh;">
	<!--begin::Wrapper-->
	<div class="w-lg-500px p-10">
		<!--begin::Form-->
		<form class="form w-100" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate="novalidate">
			<!--begin::Heading-->
			<div class="text-center mb-11">
				<!--begin::Title-->
				<h1 class="text-gray-900 fw-bolder mb-3">Login</h1>
				<!--end::Title-->
				<!--begin::Subtitle-->
				<!-- <div class="text-gray-500 fw-semibold fs-6">Your Social Campaigns</div> -->
				<!--end::Subtitle=-->
			</div>
			<!--begin::Heading-->

			<!--begin::Login Type Tabs-->
			<div class="mb-8">
				<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-bold justify-content-center">
					<li class="nav-item">
						<a class="nav-link text-active-primary pb-4"
						   [class.active]="activeTab === 'email'"
						   (click)="switchTab('email')"
						   style="cursor: pointer;">
							Email Login
						</a>
					</li>
					<li class="nav-item">
						<a class="nav-link text-active-primary pb-4"
						   [class.active]="activeTab === 'loginId'"
						   (click)="switchTab('loginId')"
						   style="cursor: pointer;">
							Login ID
						</a>
					</li>
				</ul>
			</div>
			<!--end::Login Type Tabs-->

			<!--begin::Login options-->
			<!-- <div class="row g-3 mb-9">
				<div class="col-md-6">
					<a href="#" class="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100">
						<img alt="Logo" src="assets/media/svg/brand-logos/google-icon.svg" class="h-15px me-3" />Sign in with Google</a>
				</div>
				<div class="col-md-6">
					<a href="#" class="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100">
						<img alt="Logo" src="assets/media/svg/brand-logos/apple-black.svg" class="theme-light-show h-15px me-3" />
						<img alt="Logo" src="assets/media/svg/brand-logos/apple-black-dark.svg" class="theme-dark-show h-15px me-3" />Sign in with Apple</a>
				</div>
			</div> -->
			<!--end::Login options-->
			<!--begin::Separator-->
			<!-- <div class="separator separator-content my-14">
				<span class="w-125px text-gray-500 fw-semibold fs-7">Or with email</span>
			</div> -->
			<!--end::Separator-->

			<!-- Error message display -->
			<div *ngIf="errorMessage" class="alert alert-danger mb-4" role="alert">
				<div class="d-flex align-items-center">
					<i class="ki-duotone ki-cross-circle fs-2 text-danger me-3">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<div class="d-flex flex-column">
						<span>{{ errorMessage }}</span>
					</div>
				</div>
			</div>

			<!--begin::Input group - Email-->
			<div class="fv-row mb-8" *ngIf="activeTab === 'email'">
				<!--begin::Email-->
				<input
					type="email"
					placeholder="Email"
					formControlName="email"
					autocomplete="off"
					class="form-control bg-transparent"
					[class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" />
				<!--end::Email-->
				<!-- Email validation error -->
				<div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="invalid-feedback">
					<div *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</div>
					<div *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email</div>
				</div>
			</div>
			<!--end::Input group - Email-->

			<!--begin::Input group - Login ID-->
			<div class="fv-row mb-8" *ngIf="activeTab === 'loginId'">
				<!--begin::Login ID-->
				<input
					type="text"
					placeholder="Login ID"
					formControlName="login_id"
					autocomplete="off"
					class="form-control bg-transparent"
					[class.is-invalid]="loginForm.get('login_id')?.invalid && loginForm.get('login_id')?.touched" />
				<!--end::Login ID-->
				<!-- Login ID validation error -->
				<div *ngIf="loginForm.get('login_id')?.invalid && loginForm.get('login_id')?.touched" class="invalid-feedback">
					<div *ngIf="loginForm.get('login_id')?.errors?.['required']">Login ID is required</div>
				</div>
			</div>
			<!--end::Input group - Login ID-->
			<div class="fv-row mb-3">
				<!--begin::Password-->
				<input
					type="password"
					placeholder="Password"
					formControlName="password"
					autocomplete="off"
					class="form-control bg-transparent"
					[class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" />
				<!--end::Password-->
				<!-- Password validation error -->
				<div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="invalid-feedback">
					<div *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</div>
				</div>
			</div>
			<!--end::Input group=-->
			<!--begin::Wrapper-->
			<div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
				<div class="fv-row fv-plugins-icon-container">
					<label class="form-check form-check-inline">
						<input class="form-check-input" type="checkbox" name="toc" value="1">
						<span class="form-check-label fw-semibold text-gray-700 fs-base ms-1">Remember Me</span>
					</label>
				</div>
				<!--begin::Link-->
				<a href="#" class="link-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_forgot_password">Forgot Password ?</a>
				<!--end::Link-->
			</div>
			<!--end::Wrapper-->
			<!--begin::Sign up-->
			<!-- <div class="text-gray-500 text-center fw-semibold fs-6">Not a Member yet?
				<a routerLink="/register" class="link-primary">REGISTER HERE</a>
			</div> -->
			<!--end::Sign up-->
			<!--begin::Submit button-->
			<div class="d-grid mt-8">
				<button
					type="submit"
					class="btn btn-primary indicator"
					style="min-width: 120px; height: 44px;"
					[disabled]="isLoading || loginForm.invalid">
					<!--begin::Indicator label-->
					<span class="indicator-label" *ngIf="!isLoading">Sign In</span>
					<!--end::Indicator label-->
					<!--begin::Indicator progress-->
					<span class="indicator-progress" *ngIf="isLoading">
						<span class="spinner-border spinner-border-sm align-middle me-2"></span>
						Please wait...
					</span>
					<!--end::Indicator progress-->
				</button>
			</div>
			<!--end::Submit button-->
		</form>
		<!--end::Form-->
	</div>
	<!--end::Wrapper-->
</div>
<!--end::Authentication - Sign-in-->

<app-forgot-password></app-forgot-password>

<script src="/assets/js/custom/authentication/sign-in/general.js"></script>
<script src="/assets/js/custom/account/settings/signin-methods.js"></script>

<script src="assets/js/custom/authentication/sign-in/two-factor.js"></script>
